import axiosInstance from "../http/axios_instance"
const http = axiosInstance("/protected/admin", null, "/forbidden")

const getFeeRules = (organisationId) =>
	http.get("/fee/rules", {
		params: organisationId != null ? { organisation_id: organisationId } : {},
	})

const getDefaultFeeRules = () => http.get("/fee/rules")

const saveFeeRules = (organisationId, rules) =>
	http.post("/fee/rules", { organisation_id: Number(organisationId), rules })

export default {
	getFeeRules,
	getDefaultFeeRules,
	saveFeeRules,
}
